import React, { useCallback, useEffect, useState } from 'react';
import useAuth from '../../hooks/useAuth';
import './ForgotPassword.css';

const ForgotPassword = ({email, backToLogin}) => {
  const {sendResetCode, resetByCode}                = useAuth();
  const [emailOrUsername, setEmailOrUsername]       = useState(email);
  const [resetResponse, setResetResponse]           = useState();
  const [updatePassResponse, setUpdatePassResponse] = useState();
  const [updatePassError, setUpdatePassError]       = useState();
  const [resetError, setResetError]                 = useState(null);  

  const [resetCode, setResetCode]                   = useState('');
  const [sessionCode, setSessionCode]               = useState('');
  const [newPass, setNewPass]                       = useState('');

  // --- Effect ---
  //
  useEffect(()=>{
    if (resetResponse) {
      setSessionCode(resetResponse.sessionCode);
    }
  }, [resetResponse]);
  

  // --- Update EmailOrUsername ---
  const updateEmailOrUsername = (e) => {
    const val = e.target.value;
    setEmailOrUsername(val);
  }


  // ------  Send ResetCode  ------
  //
  const handleSendResetCode = useCallback(() => {
    // Call Server
    sendResetCode(emailOrUsername)
      .then(result => setResetResponse(result))
      .catch(error => setResetError(error)); // console.error('[ForgotPassword] ERROR: ', JSON.stringify(error, null, 2))
  },[emailOrUsername, sendResetCode]);


  // ------  Update Password By Code  ------
  //
  const resetPassByCode = useCallback(() => {
    resetByCode(resetCode, sessionCode, newPass)
      .then(result => setUpdatePassResponse(result))
      // .catch(error => setUpdatePassError(error));
      .catch(error => setResetError(error));
  }, [resetCode, sessionCode, newPass, resetByCode]);


  // --- Update ResetCode ---
  const updateResetCode = (e) => {
    const val = e.target.value;
    setResetCode(val);
  }

  // --- Update NewPass ---
  const updateNewPass = (e) => {
    const val = e.target.value;
    setNewPass(val);
  }

  const step1_EnterEmail = !Boolean(resetResponse) && !Boolean(updatePassResponse);
  const step2_EnterCode  = Boolean(resetResponse) && !Boolean(updatePassResponse);
  const step3_UpdatePassResult = Boolean(updatePassResponse);

  // --- Render ---

  return (
    <div className='forgotPasswordBox'>
      {step3_UpdatePassResult && <h1>Password Updated Successfully</h1>}
      {!step3_UpdatePassResult && <h1>Reset Your Password</h1>}
      {step1_EnterEmail && <div className='resetPasswordBox'>
          <h2>Enter your email or username to get a reset code</h2>
          <div className='resetPassInputs'>
            <input className='form-control input-lg' size={40} placeholder='Email or Username' onChange={updateEmailOrUsername} value={emailOrUsername} />
          </div>
          <div className='resetPassButtonsWrap'>
            <div className='resetPassButtons'>
              <button className='resetPassBtn' onClick={handleSendResetCode}>Send Reset Code</button>
              <button className='resetPassBtn' onClick={backToLogin} style={{backgroundColor:'#385580'}}>Cancel</button>        
            </div>
          </div>
      </div>}

      {step2_EnterCode && <div className='enterCodeBox'>
        <div className='codeSentMsg'>
          <p/>
          If account exist, an email was sent.
          <p/>
          Please enter the Reset Code you received:
        </div>
        <div className='updatePassForm'> 
          <div className='updatePassLabel' style={{color:'orange', fontSize:24}}>
            Reset Code
          </div>
          <div className='updatePassVal'>
            <input className='form-control input-lg' placeholder='Reset Code' size={12} style={{fontSize: 24, letterSpacing: 8}} onChange={updateResetCode}/>
          </div>
          <div className='updatePassLabel'>
          New Password
          </div>
          <div className='updatePassVal'>
            <input className='form-control input-lg' placeholder='New Password' size={32} onChange={updateNewPass}/>
          </div>
          <div> </div>
          <div className='newPassRules'>18-32 chars: a-z / A-Z / 0-9 / any of _@`.+|- Only.</div>
        </div>

        <div className='updatePassButtons'>
          <button className='updatePassBtn' onClick={resetPassByCode}>Update My Password</button>
        </div>
      </div>}

      {step3_UpdatePassResult && <div className='updatePassResult'>
        <div>
          <a className='loginLink' href='/login'>Login</a>
        </div>
      </div>}

      <div className='resetMsg'>
        {resetError && <div className='resetErrorMsg'>
          <div className='errLineKey'>Error Code:</div>     <div className='errLineVal'> {resetError.errCode}</div>
          <div className='errLineKey'>Description:</div>    <div className='errLineVal'> {resetError.errDesc}</div> 
          <div className='errLineKey'>Message:</div>        <div className='errLineVal'> {resetError.errData?.message}</div>
          <div className='errLineKey'>cause:</div>          <div className='errLineVal'> {resetError.errData?.cause}</div>
          <div className='errLineKey'>suggestion:</div>     <div className='errLineVal'> {resetError.errData?.suggestion}</div>
          <div className='errLineKey'>logFinder:</div>      <div className='errLineVal'> {resetError.errData?.logFinder}</div>
        </div>}
        
      </div>
    </div>
  );
};

export default ForgotPassword;